import React, { useCallback, useState } from 'react'

import { CheckboxProps } from '@customTypes'
import { noop } from '_helpers/functions'

import { Checkmark, Container, Input } from './components'

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  className,
  label,
  onChangeValue = noop,
  onChange = noop,
  onClick,
  checkmarkTestId,
  containerTestId,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const onChangeRaw: React.ChangeEventHandler<HTMLInputElement> = useCallback(
    e => {
      onChangeValue(e.target.checked)
      setIsChecked(e.target.checked)
      onChange(e)
    },
    [onChange, onChangeValue]
  )

  return (
    <Container data-testid={containerTestId} id={id} className={className} role="checkbox" aria-checked={isChecked} aria-labelledby={label}>
      <p aria-hidden>{label}</p>
      <Input onChange={onChangeRaw} type="checkbox" {...props} />
      <Checkmark data-testid={checkmarkTestId} />
    </Container>
  )
}
